export default __webpack_public_path__ + "static/media/backwardIcon.0a178b52.svg";